var _title, _desc, _defs, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgWelcomeBannerCorporate = function SvgWelcomeBannerCorporate(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "381px",
    height: "209px",
    viewBox: "0 0 381 209",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "study")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M97,2.06057393e-13 C98.6568542,2.05753034e-13 100,1.34314575 100,3 L100,22.862069 C100,24.5189232 98.6568542,25.862069 97,25.862069 L13.336,25.862 L9.9137931,38.7931034 L5.73,25.862 L3,25.862069 C1.34314575,25.862069 2.02906125e-16,24.5189232 0,22.862069 L0,3 C-2.02906125e-16,1.34314575 1.34314575,2.06361753e-13 3,2.06057393e-13 L97,2.06057393e-13 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-8.0%",
    y: "-18.0%",
    width: "116.0%",
    height: "141.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowSpreadOuter2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 3,
    in: "shadowSpreadOuter2",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.12 0",
    type: "matrix",
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter3"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter3",
    result: "shadowBlurOuter3"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.14 0",
    type: "matrix",
    in: "shadowBlurOuter3",
    result: "shadowMatrixOuter3"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter3"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M97,2.06057393e-13 C98.6568542,2.05753034e-13 100,1.34314575 100,3 L100,22.862069 C100,24.5189232 98.6568542,25.862069 97,25.862069 L13.336,25.862 L9.9137931,38.7931034 L5.73,25.862 L3,25.862069 C1.34314575,25.862069 2.02906125e-16,24.5189232 0,22.862069 L0,3 C-2.02906125e-16,1.34314575 1.34314575,2.06361753e-13 3,2.06057393e-13 L97,2.06057393e-13 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-8.0%",
    y: "-18.0%",
    width: "116.0%",
    height: "141.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowSpreadOuter2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 3,
    in: "shadowSpreadOuter2",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.12 0",
    type: "matrix",
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter3"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter3",
    result: "shadowBlurOuter3"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.14 0",
    type: "matrix",
    in: "shadowBlurOuter3",
    result: "shadowMatrixOuter3"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter3"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "B2B,GL-corporate-pass",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Courses",
    transform: "translate(-897.000000, -110.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "study",
    transform: "translate(902.000000, 110.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(67.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Girl",
    transform: "translate(22.000000, 0.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.727945,77.6590455 C137.501328,68.1060322 133.710522,65.8024687 123.869007,69.0545583 C114.027491,72.306648 109.216084,75.2877301 95.8024631,77.3202862 C87.5647503,78.6753235 79.0354371,77.6590455 71.3809252,74.5424596 L43.7517823,77.1170305 C40.2525769,76.7105193 0.959415853,145.275409 0.0117143816,159.503301 C-0.571486524,168.243292 20.7882466,181.725914 26.7660559,183.080951 C29.1717597,183.622966 33.4728663,162.077872 34.8579685,160.113068 L25.8912546,157.538497 C27.495057,153.812144 32.8896654,144.59789 36.461771,139.652004 C37.5552727,138.093711 46.0845859,125.017601 47.2509877,120.003963 C47.4696881,120.478226 48.70899,129.963487 49.8753918,133.012321 C52.0623952,138.635726 55.0512998,141.820064 55.0512998,146.291687 C55.0512998,150.76331 54.4680989,168.5143 50.9688935,176.50902 C47.4696881,184.50374 42.3666801,203 42.3666801,203 L130.721617,202.525737 C130.721617,202.525737 127.514012,167.227014 128.826214,155.09943 C128.826214,155.09943 127.441112,150.221295 130.065516,143.175101 C134.366623,131.52178 135.605925,114.177302 134.876924,111.467227 C133.783422,107.19886 160.829364,143.310605 166.734273,152.457107 C169.212877,156.251212 135.605925,162.958646 132.835721,165.871977 C129.919716,168.920811 135.678825,177.186539 135.678825,177.186539 C135.678825,177.186539 194.290516,170.546856 194,162.213376 C193.707315,153.879896 161.777066,88.7025999 148.727945,77.6590455 Z",
    id: "Path",
    fill: "#00C48C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5,65 C74.8169176,74.0648633 64,76.1828204 64,76.1828204 L67.9212195,83.2309108 C80.0539386,95.140968 99.4264237,95.8003578 112.359916,84.7434905 L116.657143,76.2093568 C116.657143,76.2093568 103.867504,72.504518 100,65 C96.1324959,57.495482 80.5,65 80.5,65 Z",
    id: "Path",
    fill: "#FDC2CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.157143,48.3333333 C114.266371,54.3537691 127.193453,64.6951944 119.768283,76.4894586 C112.343113,88.2837228 108.29302,89.7740889 119.703996,109.095238 C119.703996,109.095238 109.085896,107.867562 104.226856,97.7834665 C97.385628,83.5821002 105.432241,68.0887259 107.376928,62.9796651 C109.321615,57.8706043 101.157143,48.3333333 101.157143,48.3333333 Z",
    id: "Path",
    fill: "#0E254C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.56432,40.2092919 C114.766227,34.9363015 118.501785,38.1912339 119.035436,39.2762113 C119.569087,40.3611888 118.501785,45.786076 116.36718,49.0410083 C114.232576,52.2959407 109.525773,54.7696892 109.472408,53.532815 C109.419043,52.2959407 111.56432,40.2092919 111.56432,40.2092919 Z",
    id: "Path",
    fill: "#59BBF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3456275,40.2092919 C68.1455466,34.9363015 64.4121189,38.1912339 63.878772,39.2762113 C63.3454252,40.3611888 64.4121189,45.786076 66.5455061,49.0410083 C68.6788934,52.2959407 73.3830123,54.7696892 73.4416805,53.532815 C73.5003486,52.2959407 71.3456275,40.2092919 71.3456275,40.2092919 Z",
    id: "Path",
    fill: "#FDC2CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9699817,14.3437304 C65.5212632,30.7169199 67.670836,41.1362222 71.9699817,52.0516819 C75.5006551,61.0222051 84.3300255,73.3864439 92.3909236,72.8902866 C100.451822,72.3941294 116.036225,54.5324682 114.961438,34.1900207 C113.886652,13.8475732 89.1665643,-3.5179308 71.9699817,14.3437304 Z",
    id: "Path",
    fill: "#FDC2CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1428571,6.02647875 C84.1978471,22.8906684 88.7132043,29.2569 108.462617,35.0118047 C121.122497,38.7008461 108.462617,56.6190476 108.462617,56.6190476 C108.462617,56.6190476 125.869952,47.6599469 121.122497,31.3227632 C121.122497,31.3227632 120.595002,-8.72968717 83.1428571,6.02647875 Z",
    id: "Path",
    fill: "#0E254C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.0204286,12.490782 C88.6588285,22.9658524 80.4395517,31.5828768 73.8641303,35.891389 C67.2887089,40.1999013 83.3930118,55.6082181 73.8641303,64.9738465 C69.480516,69.2823587 62.3571429,67.1281026 62.3571429,67.1281026 C62.3571429,67.1281026 76.6038892,70.8980508 67.2887089,45.0469775 C57.9735286,19.1959042 72.220275,-0.730964829 84.2752142,5.19323947 L85.0204286,12.490782 Z",
    id: "Path",
    fill: "#0E254C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.7571429,8.21895688 C84.5973043,-0.643851837 101.369318,-2.40935158 106.7,3.26546902 L98.6313596,9.66666667 L81.7571429,8.21895688 Z",
    id: "Path",
    fill: "#0E254C"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FF7B8E",
    x: 0,
    y: 198,
    width: 216,
    height: 11
  }), /*#__PURE__*/React.createElement("g", {
    id: "laptop",
    transform: "translate(47.000000, 127.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.279310884,5.56959088 C0.279310884,5.56959088 0.209701904,0.329493181 5.2911574,0.117056788 C10.3726129,-0.0953796051 117.988095,0.046244657 117.988095,0.046244657 C117.988095,0.046244657 122.721506,0.612741706 122.860724,4.50740892 C123,8.40207612 123,66.2555872 123,66.2555872 C123,66.2555872 123.06955,70.7167515 118.405749,70.8583757 C113.741947,71 4.03819577,71 4.03819577,71 C4.03819577,71 -0.068734013,69.937818 0,65.7599023 C0.0704839457,61.5819866 0.279310884,5.56959088 0.279310884,5.56959088 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#CCD0D8",
    cx: 62.1910112,
    cy: 36.1960784,
    rx: 8.29213483,
    ry: 8.35294118
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(271.000000, 79.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#A186FF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    opacity: 0.86000279,
    x: 8,
    y: 5,
    width: 15,
    height: 16,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    opacity: 0.86000279,
    x: 29,
    y: 6,
    width: 58,
    height: 3,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    fill: "#FFFFFF",
    opacity: 0.86000279,
    x: 29,
    y: 13,
    width: 37,
    height: 3,
    rx: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-5-Copy",
    transform: "translate(50.000000, 104.500000) scale(-1, 1) translate(-50.000000, -104.500000) translate(0.000000, 85.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-4)",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FF647C",
    fillRule: "evenodd",
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    opacity: 0.86000279,
    x: 75,
    y: 5,
    width: 15,
    height: 16,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    opacity: 0.86000279,
    x: 8,
    y: 6,
    width: 58,
    height: 3,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    fill: "#FFFFFF",
    opacity: 0.86000279,
    x: 29,
    y: 13,
    width: 37,
    height: 3,
    rx: 1.5
  })))))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWelcomeBannerCorporate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/welcomeBannerCorporate.bef4b688.svg";
export { ForwardRef as ReactComponent };